import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsDelete: {
        id: "app.users.users.createUser.actions.delete.text",
        defaultMessage: "Delete user",
    },
    deleteUserSuccess: {
        id: "app.users.users.createUser.delete.success.text",
        defaultMessage: "User deleted successfully.",
    },
    deleteUserTitle: {
        id: "app.users.users.createUser.delete.dialog.title.text",
        defaultMessage: "Delete user",
    },
    deleteUserDescription: {
        id: "app.users.users.createUser.delete.dialog.description.text",
        defaultMessage: "Are you sure you want to delete this user? This will permanently delete the user. The deleted user's listing will be transferred to your account. Please, type delete to confirm.",
    },
    delete: {
        id: "app.users.users.createUser.delete.dialog.delete.button.text",
        defaultMessage: "Delete",
    },
    actionsEdit: {
        id: "app.users.users.createUser.actions.edit.text",
        defaultMessage: "Edit user",
    },
    createUser: {
        id: "app.users.users.createUser.createUser.title.text",
        defaultMessage: "Add New User",
    },
});
export default messages;
